import { UserSubscriptionAction } from "common/types";

import ConfirmationDialog from "client/common/components/content/ConfirmationDialog";
import { useCurrentDialog } from "client/common/hooks/stackables";

import { useUpdateSubscriptionMutation } from "../../hooks";
import { ClientSubscription } from "../../types";

export type SubscriptionPauseDialogProps = {
  subscription: ClientSubscription;
};

const SubscriptionPauseDialog = ({ subscription }: SubscriptionPauseDialogProps) => {
  const { close } = useCurrentDialog();
  const {
    mutate: updateSubscription,
    isLoading,
    error,
  } = useUpdateSubscriptionMutation(subscription.id, {
    onSuccess: close,
  });

  return (
    <ConfirmationDialog
      title="Confirm pausing autoship"
      description="By pausing this autoship, you will no longer receive deliveries of this item until you resume this autoship."
      denyText="No, continue shipments"
      confirmText="Yes, pause autoship"
      onConfirm={() => updateSubscription({ action: UserSubscriptionAction.Pause })}
      onDeny={close}
      isLoading={isLoading}
      error={error}
    />
  );
};

export default SubscriptionPauseDialog;
